module.exports = __webpack_public_path__ + "img/letaa_al_ayad_no.f7323a95.png";